import { prefix } from "../../design-tokens/meta";
import { matchers } from "../../js/validate-props";
import { events } from "../../js/state-machine";

export const componentName = "LoadingIndicator";

export const defaultProps = Object.freeze({
    srCompletedText: "completed",
});

export const schema = Object.freeze({
    srCompletedText: matchers.string,
});

export const eventMap = Object.freeze({
    show: events.show(componentName),
    hide: events.hide(componentName),
});

export const componentClasses = Object.freeze({
    main: {
        base: `${prefix}loading-indicator`,
        sizes: {
            sm: `${prefix}loading-indicator--sm`,
            md: `${prefix}loading-indicator--md`,
            lg: `${prefix}loading-indicator--lg`,
        },
        labelPlacement: {
            top: `${prefix}loading-indicator__label--top`,
            right: `${prefix}loading-indicator__label--right`,
            left: `${prefix}loading-indicator__label--left`,
        },
    },
    overlay: {
        base: `${prefix}loading-indicator__overlay`,
        overflowHidden: `${prefix}loading-indicator__overlay--overflow-hidden`,
    },
    spinner: `${prefix}loading-indicator__spinner`,
    label: `${prefix}loading-indicator__label`,
    wrapper: `${prefix}loading-indicator__wrapper`,
    container: `${prefix}loading-indicator__container`,
});

export const views = Object.freeze({
    hidden: {
        attrs: {
            "aria-hidden": "true",
        },
    },
    visible: {
        attrs: {
            "aria-hidden": "false",
        },
    },
    body: {
        base: {
            classList: [`!${componentClasses.overlay.overflowHidden}`],
        },
        overflowHidden: {
            classList: [`${componentClasses.overlay.overflowHidden}`],
        },
    },
    label: {
        notBusy: {
            attrs: {
                "aria-busy": "false",
            },
        },
        busy: {
            attrs: {
                "aria-busy": "true",
            },
        },
    },
});
